import { filter } from 'rxjs/operators';
import { PhotoDto } from './../../../../../../models/trofaco/photoDto';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { NgoPartnerDto } from 'src/app/models/trofaco/ngoPartnerDto';
import { PlantingSiteDetailDto } from 'src/app/models/trofaco/plantingSiteDetailDto';
import { PlantingSitePartnerDto } from 'src/app/models/trofaco/plantingSitePartnerDto';
import { FileHandle, PhotoUploadComponent } from 'src/app/modules/backend/photo-upload/photo-upload.component';
import { IsInvalidDirective } from 'src/app/modules/core/directives/is-invalid.directive';
import { NgoPartnerService } from 'src/app/modules/core/services/ngo-partner.service';
declare var loadImage: any; 

export enum PhotoPosition {
  top = 1,
  middle = 2,
  bottom = 3
}
@Component({
  selector: 'app-modal-general-information',
  templateUrl: './modal-general-information.component.html',
  styleUrls: ['./modal-general-information.component.css']
})
export class ModalGeneralInformationComponent implements OnInit {
  @ViewChildren(IsInvalidDirective) isInvalidDirectives: IsInvalidDirective[];

  constructor(
    private _renderer2: Renderer2,
    
    private _bsModalService: BsModalRef,
    private el: ElementRef,
    private partnerService: NgoPartnerService
  ) { }

  public isSaved$: Subject<boolean>;
  private _onDestroy$ = new Subject();

  @Input()
  site: PlantingSiteDetailDto;

  @Input()
  _ngoPartners: PlantingSitePartnerDto[];

  @Input()
  isLandOwner : boolean;

  @Input()
  ngoPartner: NgoPartnerDto[] = [];

  @Input()
  isCreate : boolean;
  file: FileHandle;
  position = 1;
  private uploadImageClass = 'upload-file-image';
  newNgoPhoto: File;
  photo : PhotoDto;
  description : string;
  isInvildSelect :boolean = false;
  oldNgoPartner : NgoPartnerDto[];


  ngOnInit() {
    this.isSaved$ = new Subject();
    if(this.isLandOwner &&!this.isCreate && this.site.newLandOwnerPhoto){
      this.filesSelected(this.site.newLandOwnerPhoto)
    }
    else if(!this.isCreate && !this.isLandOwner && this.ngoPartner.length > 0){
      this.description = this.ngoPartner[0].description;
      this.photo = this.ngoPartner[0].photo;
      this.oldNgoPartner = this.ngoPartner;
    }
  } 

  ngOnDestroy(): void {
        this._onDestroy$.next();
        this._onDestroy$.complete();
        this.isSaved$.complete();

    const body = document.getElementsByTagName("body")[0];
    this._renderer2.removeClass(body, "modal-open");
  }

  hideNavModal() {
    this._bsModalService.hide();
  }

  async save() {
    if(this.isLandOwner){
      if (this.isInvalidDirectives.some(value => value.isInvalid)) return;
      await this.isSaved$.next(true);
      this._bsModalService.hide();
    }
    else{
      if( this.ngoPartner.length == 0) { 
        this.isInvildSelect = true;
        const ngSelect: HTMLElement = document.getElementsByClassName("ng-select-container")[0] as HTMLElement;
        ngSelect.setAttribute('style', 'border-color: #D22929;');
        return;
       }
      if (this.isInvalidDirectives.some(value => value.isInvalid)) return;
      
      this.ngoPartner[0].description = this.description;
      
      await this.partnerService.updateNgoPartner(this.ngoPartner[0]);
      if (this.newNgoPhoto) {
          var result = await this.partnerService.updateNgoPartnerPhoto(this.newNgoPhoto, this.ngoPartner[0].ngoPartnerId);
          this.ngoPartner[0].photo = result.data;      
      }
      this.checkduplicatePartner();
 
      await this.isSaved$.next(true);
      this._bsModalService.hide();
    } 
  }
  checkDuplicate(ngoPartnerId:string){
    const anyDuplicate =  this.site.partners.find(function (value) {return value.ngoPartnerId == ngoPartnerId });    
    return anyDuplicate;
  }

  checkduplicatePartner(){
    const ngoPartnerId = this.ngoPartner[0].ngoPartnerId    
    
    var anyDuplicate = this.checkDuplicate(ngoPartnerId);  
    if(anyDuplicate && this.isCreate){
      this.site.partners.splice(this.site.partners.findIndex(e => e.ngoPartnerId === ngoPartnerId),1,this.ngoPartner[0]);
    }
    else if(!this.isCreate && this.oldNgoPartner[0].ngoPartnerId === ngoPartnerId){
      this.site.partners.splice(this.site.partners.findIndex(e => e.ngoPartnerId === ngoPartnerId),1,this.ngoPartner[0]);
    }
    else if(!this.isCreate && this.oldNgoPartner[0].ngoPartnerId != ngoPartnerId){
      const anyDuplicateOldPartner = this.checkDuplicate(this.oldNgoPartner[0].ngoPartnerId);
      if(anyDuplicateOldPartner){     
        var anyDuplicateInPartner = this.checkDuplicate(ngoPartnerId);
        if(anyDuplicateInPartner){
          this.site.partners.splice(this.site.partners.findIndex(e => e.ngoPartnerId === this.oldNgoPartner[0].ngoPartnerId),1);
          this.site.partners.splice(this.site.partners.findIndex(e => e.ngoPartnerId === ngoPartnerId),1 ,this.ngoPartner[0]);
        }
        else
        {
          this.site.partners.splice(this.site.partners.findIndex(e => e.ngoPartnerId === this.oldNgoPartner[0].ngoPartnerId),1 ,this.ngoPartner[0]);
        }          
      }
    }
    else{
      this.site.partners.push(this.ngoPartner[0])
    }   
  }

  onPhotoSelected(photo: File){
    if(this.isLandOwner){
      this.site.newLandOwnerPhoto = photo;
      this.site.photoPosition = PhotoPosition.top;1
      this.site.landOwnerPhoto = null;
    }
    else{
      this.newNgoPhoto = photo;
    }
  }
  
  createNewPartner = async (name: string): Promise<PlantingSitePartnerDto> => {
    this.creatingNew = true;
    let partner = await this.partnerService.createNgoPartner({name: name, url: ''});
    this._ngoPartners.push(partner);
    this.creatingNew = false;
    return {ngoPartnerId: partner.ngoPartnerId, partnerName: partner.partnerName, partnerUrl: partner.url};
}

  creatingNew = false;
  trimAndLower(term: string, ngo: NgoPartnerDto): boolean{
    let pattern = '^' + term.trim().toLowerCase() + '$';
    let matchingRegex = new RegExp(pattern);
    return !!ngo.partnerName.toLowerCase().match(matchingRegex);
  }

  filesSelected(fileList: File) {
        let file = fileList;
        const url = window.URL.createObjectURL(file);
        this.file = {file, url};

        let options = {
            pixelRatio: window.devicePixelRatio,
            downsamplingRatio: 0.5,
            orientation: true
        }
        this.position = 1;
        
        loadImage(file, (canvas: HTMLCanvasElement) => {
            canvas.className = this.getUploadImageContainerClass();
            let myTag = this.el.nativeElement.querySelector(".canvas-img");
            this._renderer2.appendChild(myTag, canvas);
        }, options);
    }
    getUploadImageContainerClass(position: number = 1){
      if (position == 1) return `${this.uploadImageClass} top`;
      else if (position == 2) return `${this.uploadImageClass} middle`;
      return `${this.uploadImageClass} bottom`;
  }

  async onSelect(partner:NgoPartnerDto[]){   
    if(partner.length != 0){
      const partnerData =  await this.partnerService.getById(partner[0].ngoPartnerId);

      this.photo =  partnerData.photo; 
      this.description = partnerData.description;
      if(partnerData.photo){
        this.ngoPartner[0].photo = partnerData.photo;
      }

      if(this.newNgoPhoto){
        this.newNgoPhoto = null;
        const oldphoto: HTMLElement = document.getElementsByClassName("upload-file-image")[0] as HTMLElement;
        oldphoto.remove();       
      }      
      this.isInvildSelect = false;
      const ngSelect: HTMLElement = document.getElementsByClassName("ng-select-container")[0] as HTMLElement;
      ngSelect.setAttribute('style', '');
    }    
    else{
      this.photo = null 
      this.description = "";
      if(this.newNgoPhoto){
        this.newNgoPhoto = null;
        const oldphoto: HTMLElement = document.getElementsByClassName("upload-file-image")[0] as HTMLElement;
        oldphoto.remove();       
      }        
    }
  }

    
}
